const EventNames =  {
  OPEN_ADD_EDIT_ARITCLE_DIALOG: 'OPEN_ADD_EDIT_ARITCLE_DIALOG',
  CLOSE_ADD_EDIT_ARITCLE_DIALOG: 'CLOSE_ADD_EDIT_ARITCLE_DIALOG',
  OPEN_SHARE_ARTICLE_DIALOG: 'OPEN_SHARE_ARTICLE_DIALOG',
  CLOSE_SHARE_ARITCLE_DIALOG: 'CLOSE_SHARE_ARITCLE_DIALOG',
  OPEN_SHARE_ARTICLE_PREVIEW_DIALOG: 'OPEN_SHARE_ARTICLE_PREVIEW_DIALOG',
  CLOSE_SHARE_ARTICLE_PREVIEW_DIALOG: 'CLOSE_SHARE_ARTICLE_PREVIEW_DIALOG'
}

export default EventNames